<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="width: 40%">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("communication.createGlobalMessage.heading") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-flex>
                  <v-text-field outline v-model="model.days" :rules="[rules.required]" :label="$t('communication.createGlobalMessage.numberOfDays')"
                    type="number" dense></v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field outline v-model="model.step" :rules="[rules.required]" :label="$t('communication.createGlobalMessage.step')" type="number"
                    dense></v-text-field>
                </v-flex>
                <v-flex>
                  <v-textarea outline v-model="model.message" :rules="[rules.required]" :label="$t('communication.createGlobalMessage.message')" rows="4"
                    dense></v-textarea>
                </v-flex>

                <v-btn :loading="loading" block @click="createGlobalMessage" color="secondary" dark>{{ $t("common.create") }}</v-btn>
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("communication.createGlobalMessage.title");
  },
  data: () => ({
    model: {
      days: 1,
      step: 1,
      message: "",
    },

    loading: false,
    form: false,
  }),

  computed: {
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("communication.createGlobalMessage.rules.length", { length: len }),
        required: (v) => !!v || this.$t("communication.createGlobalMessage.rules.required"),
      };
    },
  },


  methods: {
    createGlobalMessage() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        if (this.model.end_time <= this.model.start_time) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("communication.createGlobalMessage.invalidHours"),
            "red"
          );
          this.loading = false;

          return;
        }
        this.axios
          .post(this.api.ACTIONS.GLOBAL_MESSAGE, {
            days: Number(this.model.days),
            step: Number(this.model.step),
            message: this.model.message,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("communication.createGlobalMessage.createdSuccessfully"), "green");
            this.$router.push("/scheduled_messages");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("communication.createGlobalMessage.checkInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      console.log(this.model);
      // }
    },
  },
};
</script>

<style scoped>
.time-container {
  display: flex;
}

.time-left,
.time-right {
  flex: 1;
  padding: 10px;
}
</style>
